import {isFeatureEnabled} from '@github-ui/feature-flags'
import {PreheatIssuesManager} from '@github-ui/preheat-issues-manager'
import {useEffect, useRef} from 'react'
import {isLoggedIn} from '@github-ui/client-env'

export function usePreheatIssues(): void {
  const managerRef = useRef<PreheatIssuesManager | null>(null)

  if (managerRef.current == null) {
    managerRef.current = new PreheatIssuesManager({
      isEnabled: () => !isFeatureEnabled('disable_preheating_for_issues') && isLoggedIn(),
      source: 'pulls',
      tabbedTimeline: isFeatureEnabled('issues_react_timeline_tabs'),
    })
  }

  useEffect(() => {
    const manager = managerRef.current
    if (!manager) return

    manager.start()
    return () => {
      manager.stop()
    }
  }, [])
}
